import React from 'react';

import AppContext from '../../../AppContext';
import { getCurrentOrder } from '../../../selectors';
import { handleSubmitDraftOrder } from '../../../utils/order';

const useSaveAsDraftModal = ({ setIsSuccessModalOpen }) => {
  const [isLoading, setIsLoading] = React.useState(false);

  const startLoading = () => {
    setIsLoading(true);
  };

  const endLoading = () => {
    setIsLoading(false);
  };

  const onSuccess = () => {
    endLoading();
    setIsSuccessModalOpen(true);
  };

  const context = React.useContext(AppContext);
  const currentOrder = getCurrentOrder(context);

  const confirmSaveAsDraft = () => {
    startLoading();
    handleSubmitDraftOrder(currentOrder, context, onSuccess, endLoading);
  };

  return { isLoading, confirmSaveAsDraft };
};

export default useSaveAsDraftModal;
